import Cookies from 'js-cookie';
import ConfigJSON from '../../../config.json';
import paginationjs from 'paginationjs';

export default function () {
    jQuery(document).ready(function ($) {
        console.log('lk/orders from router');
        let me, companies, orders;
        let companiesArray = {};

        let token = Cookies.get('lk-bearer');
        if (!token) {
            window.location = '/my-account/login';
        }

        $.ajax({
            url: LK.api_domain + '/api/v1/me',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Authorization': token,
            },
            async: true,
            contentType: 'application/json',
            complete: function (jqXHR, status) {
                me = jqXHR.responseJSON;
                if (jqXHR.status != 200) {
                    window.location = '/my-account/login';
                }

                console.log("/api/v1/me:", me);

                // update user info
                $('.lk-sidebar .mai-content .mai-content__title').text(me.data.attributes.name);
                $('.lk-sidebar .mai-content .mai-content__email').text(me.data.attributes.email);

                // update design token
                let designToken = btoa(me.data.id + '#' + me.data.id);
                $('.lk-sidebar .design-studio').attr('href', $('.lk-sidebar .design-studio').attr('href') + '?token=' + designToken);
                $('.footer-nav .design-studio').attr('href', $('.lk-sidebar .design-studio').attr('href'));
            }
        });


        $.ajax({
            url: LK.api_domain + '/api/v1/companies?page[page]=1&page[page-size]=10000',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Authorization': token,
            },
            async: true,
            contentType: 'application/json',
            complete: function (jqXHR, status) {
                companies = jqXHR.responseJSON;
                companies.data.forEach(element => {
                    companiesArray[element.id] = element;
                    companiesArray[element.id].orders = {};
                });

                console.log("/api/v1/companies:", companies);
                console.log("/api/v1/companiesArray:", companiesArray);
            }
        });

        $.ajax({
            url: LK.api_domain + '/api/v1/orders?page[page]=1&page[page-size]=10000',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'Authorization': token,
            },
            async: true,
            contentType: 'application/json',
            complete: function (jqXHR, status) {
                $('.lk-body-wrapper').show();
                $('.lk-preloader').hide();
                orders = jqXHR.responseJSON;
                console.log("/api/v1/orders?page[page]=*&page[page-size]=*:", orders);

                orders.data.forEach(function (v, i) {
                    if (v.hasOwnProperty('attributes') && v.attributes.hasOwnProperty('company_id')) {
                        companiesArray[v.attributes.company_id].orders[v.id] = v;
                    }
                });

                console.log(companiesArray);

                // update budge on sidebar
                $('.lk-sidebar .lk-sidebar__menu-link-badge').text(orders.meta.total).css('visibility', 'visible');
                $('.footer-nav .footer-nav__button-badge').text(orders.meta.total);

                // fill company/orders accordion
                $('.orders-wrapper .company-list').empty();

                $('.orders-wrapper .orders-pagination').pagination({
                    dataSource: Object.values(companiesArray),
                    pageSize: 10,
                    hideFirstOnEllipsisShow: true,
                    callback: function (data, pagination) {
                        // template method of yourself
                        var html = templateOrders(data);
                        $('.orders-wrapper .company-list').html(html);
                    }
                })

                function templateOrders(data) {
                    console.log(data);
                    let res = '';

                    data.forEach(function (company, index) {
                        //let company = companiesArray[companyId];
                        let companyId = company.id;
                        let companyItem = `
                        <div class="company-list__item">
                        <div class="cli__title">
                            ${company.attributes.name}
                            <span class="cli__arrow">
                                <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path id="Vector 13" d="M1 1L7.125 6.6648C7.60825 7.11174 8.39175 7.11174 8.875 6.6648L15 1" stroke="#262633" stroke-linecap="round" />
                                </svg>
                            </span>
                        </div>
                        <div class="orders-list">`;

                        for (let orderId in companiesArray[companyId].orders) {
                            let order = companiesArray[companyId].orders[orderId];

                            let percent = 100;
                            let totalStepCount = 0;
                            let comletedStepCount = 0;
                            order.relationships.steps.data.forEach(function (step, index) {
                                totalStepCount++;

                                if (step.attributes['step-completed']) {
                                    comletedStepCount++;
                                }
                            });

                            percent = Math.round(comletedStepCount * 100 / totalStepCount);
                            // calc percent
                            companyItem += `<div class="orders-list__item" data-companyId="${companyId}" data-orderId="${orderId}">
                                            <div class="oli__text">${order.id}</div>
                                            <div class="oli__percents">${percent}%</div>
                                        </div>`;
                        }
                        companyItem += `
                        </div>
                    </div>
                    `;

                        res += companyItem;
                    });

                    return res;
                }

                /*
                for (let companyId in companiesArray) {
                    let company = companiesArray[companyId];
                    let companyItem = `
                        <div class="company-list__item">
                        <div class="cli__title">
                            ${company.attributes.name}
                            <span class="cli__arrow">
                                <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path id="Vector 13" d="M1 1L7.125 6.6648C7.60825 7.11174 8.39175 7.11174 8.875 6.6648L15 1" stroke="#262633" stroke-linecap="round" />
                                </svg>
                            </span>
                        </div>
                        <div class="orders-list">`;

                    for (let orderId in companiesArray[companyId].orders) {
                        let order = companiesArray[companyId].orders[orderId];

                        let percent = 100;
                        let totalStepCount = 0;
                        let comletedStepCount = 0;
                        order.relationships.steps.data.forEach(function (step, index) {
                            totalStepCount++;

                            if (step.attributes['step-completed']) {
                                comletedStepCount++;
                            }
                        });

                        percent = Math.round(comletedStepCount * 100 / totalStepCount);
                        // calc percent
                        companyItem += `<div class="orders-list__item" data-companyId="${companyId}" data-orderId="${orderId}">
                                            <div class="oli__text">${order.id}</div>
                                            <div class="oli__percents">${percent}%</div>
                                        </div>`;
                    }
                    companyItem += `
                        </div>
                    </div>
                    `;

                    //$('.orders-wrapper .company-list').append(companyItem);
                }
                */
            }
        });

        $('.orders-wrapper').on('click', '.orders-list .orders-list__item', function (e) {
            e.preventDefault();
            $("html, body").animate({ scrollTop: 0 });

            let companyId = $(this).attr('data-companyId');
            let orderId = $(this).attr('data-orderId');
            let order = companiesArray[companyId].orders[orderId];

            $('.orders-info-wrapper .orders-info__title span').text(orderId);
            $('.orders-info-wrapper .orders-info__download-doc').attr('data-companyId', companyId).attr('data-orderId', orderId).hide();
            $('.orders-info-wrapper .orders-info__title-download-doc').attr('data-companyId', companyId).attr('data-orderId', orderId).hide();

            $('.orders-info-wrapper .orders-info__list').empty();
            order.relationships.steps.data.forEach(function (step, index) {
                let doneClass = '';
                if (step.attributes['step-completed']) {
                    doneClass = 'done';
                }

                let oilItem = `<div class="oil__item ${doneClass}">
                                    ${step.relationships['algorithm-step'].data.attributes['step-text']}
                                </div>`;
                $('.orders-info-wrapper .orders-info__list').append(oilItem);
            });


            if (window.innerWidth < ConfigJSON.desktopBreakWidth) {
                $('.lk-content-wrapper .orders-wrapper').hide();
                $('.lk-content-wrapper .orders-info-wrapper').show();
            } else {
                $('.lk-content-wrapper .orders-info-wrapper').show();
            }

            // fetch doc for order
            $.ajax({
                url: LK.api_domain + `/api/v1/orders/${orderId}/documents`,
                method: 'GET',
                xhrFields: {
                    withCredentials: true
                },
                headers: {
                    'Authorization': token,
                },
                async: true,
                contentType: 'application/json',
                complete: function (jqXHR, status) {
                    let documents = jqXHR.responseJSON;
                    if (jqXHR.status != 200) {
                        window.location = '/my-account/login';
                    }

                    console.log(`/api/v1/orders/${orderId}/documents:`, documents);
                    console.log(documents.data.length);

                    if (documents.data.length) {
                        if (window.innerWidth >= ConfigJSON.desktopBreakWidth) {
                            $('.orders-info-wrapper .orders-info__download-doc').show();
                        } else {
                            $('.orders-info-wrapper .orders-info__title-download-doc').show();
                        }
                    }

                    $('.documents-wrapper .orders-list .documents-list').empty();
                    $('.documents-wrapper .orders-list .oli__title span.text').text('Order ' + orderId);

                    documents.data.forEach(function (doc, index) {
                        let item = `<div class="documents-list__item">
                                        <div class="dli__text" data-doc-url="${LK.aws_domain}/${doc.attributes['s3-key']}">${doc.attributes.name}</div>
                                    </div>`;

                        $('.documents-wrapper .orders-list .documents-list').append(item);
                    });
                }
            });

        });

        // Click on download documents
        $('.lk-content-wrapper .orders-info-wrapper .orders-info__download-doc, .lk-content-wrapper .orders-info-wrapper .orders-info__title-download-doc').on('click', function (e) {
            e.preventDefault();

            $('.lk-content-wrapper .orders-wrapper').hide();
            $('.lk-content-wrapper .orders-info-wrapper').hide();
            $('.lk-content-wrapper .documents-wrapper').show();
            $('.lk-content-wrapper .document-info-wrapper object').remove();

            if (window.innerWidth >= ConfigJSON.desktopBreakWidth) {
                $('.lk-content-wrapper .document-info-wrapper').show();
            }

        });

    });
};